export const ThreeStarsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 74 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.5 29L49.1839 34.1824H54.6329L50.2245 37.3853L51.9084 42.5676L47.5 39.3647L43.0916 42.5676L44.7755 37.3853L40.3671 34.1824H45.8161L47.5 29Z"
        fill="currentColor"
      />
      <path
        d="M26.5 29L28.1839 34.1824H33.6329L29.2245 37.3853L30.9084 42.5676L26.5 39.3647L22.0916 42.5676L23.7755 37.3853L19.3671 34.1824H24.8161L26.5 29Z"
        fill="currentColor"
      />
      <path
        d="M36.5 10L38.1839 15.1824H43.6329L39.2245 18.3853L40.9084 23.5676L36.5 20.3647L32.0916 23.5676L33.7755 18.3853L29.3671 15.1824H34.8161L36.5 10Z"
        fill="currentColor"
      />
    </svg>
  );
};
